import React from "react";
import { useDispatch } from "react-redux";
import { setOpenWalletModal } from "../redux/connect-wallet/connectWallet";

const ConnectWalletButtonMain = () => {
  const dispatch = useDispatch();
  return (
    <button
      type="button"
      onClick={() => dispatch(setOpenWalletModal(true))}
      className="w-full h-14 text-base leading-6 font-medium rounded-lg border text-white border-white
       shadow-swapButton transition-colors duration-300 bg-deepBlue hover:bg-vividBlueViolet active:bg-[#1E31FF] 
       flex items-center justify-center"
    >
      Connect Wallet
    </button>
  );
};

export default ConnectWalletButtonMain;
